$(document).ready(function () {
    const carousel = $('.ddi-carousel');
    let initialPadding = 0;

    carousel.on('initialized.owl.carousel', function() {
        initialPadding = carousel.find('.owl-stage').css('padding-left');
    });

    carousel.owlCarousel({
        nav: true,
        responsive: {
            0: {
                items: 1
            },
            768: {
                items: 2,
                margin: 25,
            },
            1024: {
                items: 1,
                stagePadding: 200,
                startPosition: 1,
                margin: 25,
            },
            1450: {
                items: 2,
                stagePadding: 200,
                startPosition: 1,
                margin: 25,
            },
        },
    });

    carousel.on('translate.owl.carousel', function(event) {
        const stage = carousel.find('.owl-stage');

        if (event.item.index === 0) {
            stage.css('padding-left', 0);
        } else {
            stage.css('padding-left', initialPadding);
        }
    });
});
